// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2FnIm","col":"styles_col__3cePn","fulfillmentStatus":"styles_fulfillmentStatus__2tHYL","emailCol":"styles_emailCol__yrdwi"};